import HtmlLogo from "../assets/svg/html-logo.svg";
import CssLogo from "../assets/svg/css-logo.svg";
import JsLogo from "../assets/svg/js-logo.svg";
import TsLogo from "../assets/svg/ts-logo.svg";
import ReactLogo from "../assets/svg/react-logo.svg";
import NextJsLogo from "../assets/svg/nextjs-icon.svg";
import ReduxLogo from "../assets/svg/redux-logo.svg";
import BootstrapLogo from "../assets/svg/bootstrap-logo.svg";
import MuiLogo from "../assets/svg/mui-logo.svg";
import TailwindLogo from "../assets/svg/tailwind-logo.svg";
import JestLogo from "../assets/svg/jest-logo.svg";
import JiraLogo from "../assets/svg/jira-logo.svg";
import PostmanLogo from "../assets/svg/postman-logo.svg";
import GithubLogo from "../assets/svg/github-logo.svg";
import GitlabLogo from "../assets/svg/gitlab-logo.svg";
import VsCodeLogo from "../assets/svg/vscode-logo.svg";
import JobLogo from "../assets/svg/job-logo.svg";
import NsThumbnail from "../assets/images/Newton-thumbnail.png";
import AotThumbnail from "../assets/images/aot-thumbnail.jpg";
import KnhsThumbnail from "../assets/images/knhs-thumbnail.jpg";
import KhsThumbnail from "../assets/images/khs-thumbnail.jpg";
import TicTacToeThumbnail from "../assets/images/projectsThumbnail/tic-tac-toe.png";
import ArtGalleryThumnail from "../assets/images/projectsThumbnail/art-gallery.png";
import SnakeGameThumbnail from "../assets/images/projectsThumbnail/snake-game.gif";


export const Bio = {
  name: "Anirban Konar",
  roles: [
    "Web Developer🚀",
    "Programmer 🧑‍💻",
    "Artist🎨",
  ],
  description:
    "I am a dedicated Front-End Developer with over four years of hands-on experience building intuitive, high-performance web interfaces. My strong passion for development, combined with a continuous drive to learn and refine my skills, has fueled my growth and success in this fast-evolving industry.",
  github: "https://github.com/I-am-ani",
  resume: "https://drive.google.com/file/d/1lY-UR4--Q8kzEKwZ_98_0mQ-ICJXaW-u/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/anirban-konar-42563a96/",
  twitter: "https://twitter.com/konar007",
  insta: "https://www.instagram.com/ani_r_ban_01/",
  whatsapp: "https://api.whatsapp.com/send?phone=918617282549",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image: ReactLogo,
      },
      {
        name: "Next Js",
        image: NextJsLogo,
      },
      {
        name: "Redux",
        image: ReduxLogo
      },
      {
        name: "JavaScript",
        image: JsLogo,
      },
      {
        name: "TypeScript",
        image: TsLogo,
      },
      {
        name: "HTML",
        image: HtmlLogo,
      },
      {
        name: "CSS",
        image: CssLogo,
      },
      {
        name: "Material UI",
        image: MuiLogo,
      },
      {
        name: "Bootstrap",
        image: BootstrapLogo,
      },
      {
        name: "Tailwind Css",
        image: TailwindLogo,
      },
      {
        name: "Jest",
        image: JestLogo,
      },
    ],
  },
  // {
  //   title: "Backend",
  //   skills: [
  //     {
  //       name: "Node Js",
  //       image: "https://nodejs.org/static/images/logo.svg",
  //     },
  //     {
  //       name: "Express Js",
  //       image:
  //         "data:image/png;base64,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",
  //     },
  //     {
  //       name: "MongoDB",
  //       image:
  //         "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
  //     },
  //     {
  //       name: "Firebase",
  //       image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
  //     },
  //   ],
  // },
  {
    title: "Other Tools",
    skills: [
      {
        name: "VS Code",
        image: VsCodeLogo
      },
      {
        name: "Gitlab",
        image: GitlabLogo
      },
      {
        name: "Postman",
        image: PostmanLogo
      },
      {
        name: "GitHub",
        image: GithubLogo,
      },
      {
        name: "Figma",
        image:
          "https://img.icons8.com/color/96/figma--v1.png",
      },
      {
        name: "Jira",
        image: JiraLogo,
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: JobLogo,
    role: "Software Development Engineer",
    company: "Logichive Solutions Pvt. Ltd.",
    date: "Aug 2022 - Present",
    desc: "Worked as a web-developer.",
    skills: [
      "React JS",
      "Next JS",
      "Redux",
      "TypeScript"
    ],
    // doc: "https://media.discordapp.net/attachments/750764661980397598/1146511155687346317/image.png?width=910&height=638",
  },
  {
    id: 1,
    img: JobLogo,
    role: "Senior Engineer",
    company: "India Engineering Company",
    date: "May 2019 - Sep 2021",
    desc: "Worked as an electrical engineer and responsible for electrical maintenance job.",
    skills: [
      "AutoCAD",
      "Project Management",
      "Leadership",
      "Team Work",
    ],
    // doc: "https://media.discordapp.net/attachments/750764661980397598/1146510994839978066/image.png?width=478&height=638",
  },
  {
    id: 2,
    img: JobLogo,
    company: "Indusree",
    role: "Senior Engineer",
    date: "Jun 2016 - Mar 2019",
    desc: "Worked as a senior engineer and responsible for designing and quality control.",
    skills: [
      "AutoCAD",
      "Project Management",
      "Quality Control",
      "Team Work",
    ],
    // doc:"https://drive.google.com/file/d/1QMsbH0MQuL-r8NmFEe7VIz6eaxqKdFkk/view?usp=drive_link"
  },
];

export const education = [
  {
    id: 0,
    img: NsThumbnail,
    school: "Newton School (Online Platform)",
    date: "December 2021 - March 2023",
    degree: "Course: Full Stack Web Development",
    grade: "",
    doclink: "https://my.newtonschool.co/course/yc3dvm9d03g5/certificate/xs58yxp2ez1t/verify/",
  },
  {
    id: 1,
    img: AotThumbnail,
    school: "Academy of Technology",
    date: "July 2010 - July 2014",
    grade: "7.95 DGPA",
    desc: "I have completed Bachelor's degree in Electrical Engineering from Academy of Technology, Hooghly, W.B.",
    degree: "Bachelor of Technology - Electrical Engineering (WBUT)",
    doclink: ""
  },
  {
    id: 2,
    img: KnhsThumbnail,
    school: "Kamalpur Netaji High School",
    date: "Apr 2007 - Apr 2009",
    grade: "77.2%",
    desc: "I have completed my class 12 high school on science stream education from Kamalpur Netaji High School, W.B.",
    degree: "Higher Secondary Education (WBCHSE)",
    doclink: ""
  },
  {
    id: 3,
    img: KhsThumbnail,
    school: "Kanksa High School",
    date: "Apr 2005 - Apr 2007",
    grade: "90.00%",
    desc: "I have completed my secondary education from Kanksa High School, W.B.",
    degree: "Secondary Education (WBBSE)",
    doclink: ""
  },
];

export const projects = [
  {
    id: 0,
    title: "Art Gallery",
    date: "Jun 2023 - Jul 2023",
    description:
      "Canvas Chronicles: A Visual Journey through my Art Gallery",
    image: ArtGalleryThumnail,
    // "https://media.discordapp.net/attachments/750764661980397598/1146509877187985418/image.png?width=1248&height=637",
    tags: ["React JS", "JavaScript", "Material UI",],
    category: "web app",
    github: "https://github.com/I-am-ani/art-gallery-by-anirban",
    webapp: "https://i-am-ani.github.io/art-gallery-by-anirban/",
  },
  {
    id: 1,
    title: "Tic-tac-toe",
    date: "Jul 2023 -  2023",
    description:
      "Tic Tac Toe is a two-player game in which the objective is to take turns and mark the correct spaces in a 3x3 grid.",
    image: TicTacToeThumbnail,
    tags: ["Html", "CSS", "JavaScript",],
    category: "game",
    github: "https://github.com/I-am-ani/Tic_Tac_Toe_JS",
    webapp: "https://i-am-ani.github.io/Tic_Tac_Toe_JS/",
  },
  {
    id: 2,
    title: "Keyboard controlled game",
    date: "Jul 2023 -  2023",
    description:
      "Tic Tac Toe is a two-player game in which the objective is to take turns and mark the correct spaces in a 3x3 grid.",
    image: SnakeGameThumbnail,
    tags: ["Html", "CSS", "JavaScript",],
    category: "game",
    github: "https://github.com/I-am-ani/SnakeGame_AK",
    webapp: "https://i-am-ani.github.io/SnakeGame_AK/",
  },
  // {
  //   id: 1,
  //   title: "Ecommerce App",
  //   date: "May 2023 - May 2023",
  //   description:
  //     "Ecommerce app made using React JS and Firebase. User can create account , login using credentials and add items to cart. Used react router dom to navigate between homepage, login, page, register page and cart page.. Managed state of the cart items using Context API.",
  //   image:
  //     "https://media.discordapp.net/attachments/750764661980397598/1142059598375817267/image.png?width=1223&height=638",
  //   tags: [
  //     "React Js",
  //     "Firebase",
  //     "CSS",
  //     "Material UI",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/kaustavsarkar14/amazon-clone",
  //   webapp: "https://amazon-clone-app02.netlify.app/",
  // },
  // {
  //   id: 2,
  //   title: "IMDB - movie browser",
  //   date: "Nov 2022 - Nov 2022",
  //   description:
  //     "An Web app where user can browse through movies.There are sections for popular, top rated and upcoming movies.",
  //   image:
  //     "https://media.discordapp.net/attachments/750764661980397598/1142059512480682025/image.png?width=1226&height=638",
  //   tags: ["React Js", "React Router DOM", "TMDB API",],
  //   category: "web app",
  //   github: "https://imdb-clone-webapp.netlify.app/",
  //   webapp: "https://imdb-clone-webapp.netlify.app/",
  //   member: [
  //   ],
  // },
];

export const Slogan = "Made with ❤️ in India";
export const CopyrightText = "© 2025 Anirban Konar. All rights reserved.";